module.exports = __webpack_public_path__ + "img/Rating.24de12c9.svg";